import { DistributionListGroup } from './distribution-list.model';

/** Shown when the entered email belongs to a user other than the one being edited. */
export const EMAIL_BELONGS_TO_OTHER_MESSAGE =
  'This email already belongs to another user. Please use a different email.';

/** Known list sheets (id, display name, color). Colors are reused for unknown sheets. */
export const DISTRIBUTION_LIST_GROUPS: readonly DistributionListGroup[] = [
  { id: 'primary', name: 'Master', color: '#818F99', isDefault: true },
  { id: 'red', name: 'Red', color: '#C21228', isDefault: true },
  { id: 'yellow', name: 'Yellow', color: '#D9B100', isDefault: true },
  { id: 'green', name: 'Green', color: '#32B877', isDefault: true },
  { id: 'blue', name: 'Blue', color: '#40B3D4', isDefault: false },
  { id: 'purple', name: 'Purple', color: '#9957BE', isDefault: false },
];
